import { supabase } from '@/integrations/supabase/client';

export const fetchSavedSupportPackSlugs = async (userId: string) => {
  const { data, error } = await supabase
    .from('saved_support_packs')
    .select('pack_slug')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return (data ?? []).map((item) => item.pack_slug);
};

export const toggleSavedSupportPack = async (packSlug: string, userId: string, saved: boolean) => {
  if (saved) {
    return supabase.from('saved_support_packs').delete().eq('pack_slug', packSlug).eq('user_id', userId);
  }

  return supabase.from('saved_support_packs').insert({ pack_slug: packSlug, user_id: userId });
};
